import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';
import { InspectionPointType } from './inspection-point-type';
import { InspectionPointSvgPosition } from './inspection-point-svg-position';

export class InspectionPoint implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Inspection Point';
  readonly apiRoute: string = CONFIG.apiRoutes.drawingInspectionDetails;

  inspectionPointId: string;
  name: string;
  inspectionPointTypeId: string;
  inspectionPointType: InspectionPointType = new InspectionPointType();
  mediaItemDetailsId: string;
  thicknessLocationId: string;
  svgPosition = new InspectionPointSvgPosition();

  get isAdHoc(): boolean {
    return !this.thicknessLocationId || this.thicknessLocationId === CONFIG.constants.emptyGuid;
  }

  public json(): any {
    return this;
  }

  loadFromJson(data: any) {
    this.inspectionPointId = data.inspectionPointId;
    this.name = data.name;
    this.inspectionPointTypeId = data.inspectionPointTypeId;

    if (data.inspectionPointType) {
      this.inspectionPointType = new InspectionPointType();
      this.inspectionPointType.loadFromJson(data.inspectionPointType);
    }

    this.mediaItemDetailsId = data.mediaItemDetailsId;
    this.thicknessLocationId = data.thicknessLocationId;

    this.svgPosition = new InspectionPointSvgPosition();

    if (data.svgPosition) {
      this.svgPosition.loadFromJson(data.svgPosition);
    }
  }
}
